import React, { useEffect, useState, useRef } from "react";
import Chart from "chart.js/auto";
import "chartjs-adapter-date-fns";
import "./Relatorios.css";
import { formatarDataBrasil } from "../utils/utils";


const Relatorios = () => {
  const [dados, setDados] = useState(null);
  const [periodoInicio, setPeriodoInicio] = useState("");
  const [periodoFim, setPeriodoFim] = useState("");
  const [intervaloExibido, setIntervaloExibido] = useState("");
  const [preset, setPreset] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [tipoUsuario, setTipoUsuario] = useState("");
  const [usuarioSelecionado, setUsuarioSelecionado] = useState("");





  const chartsRef = {
    origem: useRef(null),
    objecoes: useRef(null),
    acoes: useRef(null),
    funil: useRef(null),
    pendentes: useRef(null),
    leads: useRef(null),
  };

  
// Primeiro: carregar tipo do usuário e usuários
useEffect(() => {
  fetch("https://welaunchyou.com.br/crm-wly/listagem_usuarios.php", {
    credentials: "include"
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.usuarios) setUsuarios(data.usuarios);
      if (data.tipo_usuario) setTipoUsuario(data.tipo_usuario);
    });
}, []);

// Segundo: só chama a API depois que tipoUsuario foi carregado
useEffect(() => {
  if (tipoUsuario) {
    buscarRelatorios();
  }
}, [tipoUsuario]);



useEffect(() => {
  if (dados && Object.keys(dados).length > 0) {
      renderCharts();
  }
}, [dados]); 


  const buscarRelatorios = async (customInicio = null, customFim = null) => {
  try {
    const params = new URLSearchParams();
    const inicio = customInicio || periodoInicio;
    const fim = customFim || periodoFim;

    if (inicio) params.append("periodo_inicio", inicio);
    if (fim) params.append("periodo_fim", fim);

    // 🔥 Aqui está o que faltava
    if (tipoUsuario === "master" && usuarioSelecionado) {
      params.append("usuario_id", usuarioSelecionado);
    }

    const response = await fetch(
      `https://welaunchyou.com.br/crm-wly/relatorios.php?${params.toString()}`,
      { credentials: "include" }
    );
    const data = await response.json();
    console.log("Dados recebidos:", data);

    setDados(data);

    if (inicio && fim) {
      setIntervaloExibido(
        `Exibindo dados de ${formatarDataBrasil(inicio)} a ${formatarDataBrasil(fim)}`
      );
    }
  } catch (error) {
    console.error("Erro ao buscar relatórios:", error);
  }
};


  const handlePreset = (presetSelecionado) => {
    setPreset(presetSelecionado);

    let inicio, fim;
    const hoje = new Date();

    switch (presetSelecionado) {
      case "7d":
        inicio = new Date();
        inicio.setDate(hoje.getDate() - 7);
        fim = hoje;
        break;
      case "30d":
        inicio = new Date();
        inicio.setDate(hoje.getDate() - 30);
        fim = hoje;
        break;
      case "current_month":
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        break;
      case "last_month":
        inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
        break;
      default:
        return;
    }

    const inicioFormatado = inicio.toISOString().split("T")[0];
    const fimFormatado = fim.toISOString().split("T")[0];

    setPeriodoInicio(inicioFormatado);
    setPeriodoFim(fimFormatado);

    buscarRelatorios(inicioFormatado, fimFormatado);
  };

  const chartConfigs = [
    {
      type: "custom",
      label: "Resumo dos Dados",
      render: () => (
        <div className="chart-card resumo-dados">
          <h3>Resumo dos Dados</h3>
          <ul>
            <li><strong>📌 Leads:</strong> {dados?.totais?.leads || 0}</li>
            <li><strong>📌 Objeções:</strong> {dados?.totais?.objecoes || 0}</li>
            <li><strong>📌 Ações Concluídas:</strong> {dados?.totais?.acoes || 0}</li>
          </ul>
        </div>
      ),
    },
    {
      ref: chartsRef.origem,
      type: "pie",
      labels: dados?.origem?.map((item) => item.origem_lead) || [],
      values: dados?.origem?.map((item) => item.total) || [],
      label: "Origem dos Leads",
    },
    {
      ref: chartsRef.objecoes,
      type: "bar",
      labels: dados?.objecoes?.map((item) => item.descricao) || [],
      values: dados?.objecoes?.map((item) => item.total) || [],
      label: "Objeções dos Leads",
    },
    {
      ref: chartsRef.acoes,
      type: "bar",
      labels: dados?.acoes_concluidas?.map((item) => formatarDataBrasil(item.data)) || [],
      values: dados?.acoes_concluidas?.map((item) => item.total) || [],
      label: "Ações Concluídas",
    },
    {
      ref: chartsRef.funil,
      type: "bar",
      labels: dados?.funil?.map((item) => item.estagio_funil) || [],
      values: dados?.funil?.map((item) => item.total) || [],
      label: "Leads por Estágio",
    },
    {
      ref: chartsRef.pendentes,
      type: "line",
      labels: dados?.acoes_pendentes?.map((item) => formatarDataBrasil(item.data)) || [],
      values: dados?.acoes_pendentes?.map((item) => item.total) || [],
      label: "Ações Pendentes",
    },
    {
      ref: chartsRef.leads,
      type: "line",
      labels: dados?.leads_por_data?.map((item) => formatarDataBrasil(item.data)) || [],
      values: dados?.leads_por_data?.map((item) => item.total) || [],
      label: "Leads por Data",
    },
  ];

  const renderCharts = () => {
    if (!dados) return;

    chartConfigs.forEach(({ ref, type, labels, values, label }) => {
      if (!ref || type === "custom") return;

      if (ref.current && labels.length > 0 && values.length > 0) {
        if (ref.current.chart) {
          ref.current.chart.destroy();
        }

        ref.current.chart = new Chart(ref.current, {
          type,
          data: {
            labels,
            datasets: [
              {
                label,
                data: values,
                backgroundColor: ["#145A32", "#1E8449", "#28B463", "#52BE80", "#7DCEA0"],
                borderColor: "#145A32",
                borderWidth: 1.5,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      }
    });
  };

  return (
    <div className="container-relatorios">
      <h1 style={{ borderBottom: "none" }}>Relatórios</h1>
      <h2 className="intervalo-selecionado" style={{ borderBottom: "none" }}>{intervaloExibido}</h2>

      <form className="filter-form-relat">
{tipoUsuario === "master" && (
  <div>
    <label>Usuário:</label>
<select
  value={usuarioSelecionado}
  onChange={(e) => {
    const novoUsuarioId = e.target.value;
    setUsuarioSelecionado(novoUsuarioId);
    buscarRelatorios(); // Chama nova consulta com o usuário selecionado
  }}
>
  <option value="">Todos</option>
  {usuarios.map((user) => (
    <option key={user.id} value={user.id}>
      {user.nome_empresa}
    </option>
  ))}
</select>

  </div>
)}


  <div className="filter-container-relat">
    <label>Período:</label>
    <input type="date" value={periodoInicio} onChange={(e) => setPeriodoInicio(e.target.value)} />
    <input type="date" value={periodoFim} onChange={(e) => setPeriodoFim(e.target.value)} />
    <button type="button" onClick={() => buscarRelatorios()}>Filtrar</button>

    <div className="presets">
  <button type="button" onClick={() => handlePreset("7d")}>Últimos 7 dias</button>
  <button type="button" onClick={() => handlePreset("30d")}>Últimos 30 dias</button>
  <button type="button" onClick={() => handlePreset("current_month")}>Este mês</button>
  <button type="button" onClick={() => handlePreset("last_month")}>Mês passado</button>
</div>

  </div>
</form>

     <div className="charts">
        {chartConfigs.map(({ ref, render }) =>
          render ? render() : (
            <div className="chart-card" key={ref}>
              <h3>{ref.current?.chart?.config?.data?.datasets[0]?.label || "Gráfico"}</h3>
              <canvas ref={ref}></canvas>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Relatorios;
